<template>
  <div class="grid-x grid-padding-x align-center">
    <div class="cell medium-12 large-3 small-order-2 large-order-1">
      <adult-basic-education-transfer-search-filters-component
        :nonce="nonce"
        :apiUrls="apiUrls"
        ref="searchFiltersComponentRef"
        @onSubmit="submit"
        is-on-results-page="true"
        base-page-path="/transfer-options/adult-basic-education/"
        results-page-path="/transfer-options/adult-basic-education/search-result/"
      >
      </adult-basic-education-transfer-search-filters-component>
    </div>

    <div class="cell medium-12 large-9 small-order-1 large-order-2 o-search-result">
      Search Result
      <div class="o-search-results">
        <div class="o-search-results__header s-content-block s-content-block--small">
          <div class="o-search-results__title">
            <h3>Adult Basic Education Transfer</h3>
            <div class="o-search-results__button">
              <form id="save-to-pdf-form" target="_blank" method="POST"></form>
              <button
                type="button"
                class="a-button a-button--small a-button--primary-outline"
                @click="downloadPdf"
              >
                Save to PDF
              </button>
              <button type="button" class="a-button a-button--small" @click="newSearch">
                New Search
              </button>
            </div>
          </div>
        </div>

        <div class="s-content-block s-content-block--small">
          <div class="o-search-result__table-total-page">
            <div class="text-center medium-text-left">
              {{ pageFrom }} to {{ pageTo }} of {{ totalAgreements }} matches <br />
            </div>

            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">{{ page }}</button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
          <div class="o-search-results__table-wrapper">
            <div
              class="o-search-results__table"
              v-if="
                searchResponse.disciplines != null &&
                _.get(searchResponse, 'disciplines.length') > 0
              "
            >
              <!-- Headers -->
              <div class="o-search-results__table-header adult-basic-education">
                <div class="grid-x">
                  <div class="cell small-2"><strong>Discipline</strong></div>
                  <div class="cell small-10 cell-no-padding">
                    <div class="grid-x">
                      <div class="cell small-3"><strong>Level</strong></div>
                      <div class="cell small-9 cell-no-padding">
                        <div class="grid-x">
                          <div class="cell small-4">
                            <strong>Institution</strong>
                          </div>
                          <div class="cell small-5">
                            <strong>Transfer Credit</strong>
                          </div>
                          <div class="cell small-3">
                            <strong>Effective Date</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="o-search-results__table-row adult-basic-education">
                <div
                  class="grid-x"
                  v-for="discipline in searchResponse.disciplines"
                  :key="discipline.disciplineId"
                >
                  <!-- Discipline -->
                  <div class="cell small-2">
                    <div class="flex-container">
                      <span>{{ discipline.disciplineName }}</span>
                    </div>
                  </div>

                  <!-- Level -->
                  <div class="cell small-10 cell-no-padding">
                    <div class="grid-x" v-for="level in discipline.levels" :key="level.levelId">
                      <div class="cell small-3">
                        <div class="flex-container">
                          {{ level.levelName }}
                        </div>
                      </div>

                      <div class="cell small-9 cell-no-padding">
                        <div
                          class="grid-x"
                          v-for="agreement in level.agreements"
                          :key="agreement.id"
                        >
                          <!-- Institution -->
                          <div class="cell small-4">
                            <div class="flex-container">
                              <div
                                class="o-search-results__logo"
                                :data-tooltip="agreement.senderInstitutionName"
                              >
                                <img
                                  :src="`${logosUrl}/${agreement.sndrGlobalInstitutionID}_icon.png`"
                                />
                              </div>
                              <span>{{ agreement.senderInstitutionCode }}</span>
                            </div>
                          </div>

                          <!-- Transfer Credit -->
                          <div class="cell small-5" style="display: inline">
                            {{ agreement.detail
                            }}{{ agreement.condition ? `, ${agreement.condition}` : '' }}
                            <div
                              v-html="buildTrailingAttributes(agreement.trailingAttributes)"
                              style="display: inline"
                            ></div>
                          </div>

                          <!-- Effective Date -->
                          <div class="cell small-3">
                            {{ agreementEffectiveDateDate(agreement) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h6 v-else-if="_.get(searchResponse, 'disciplines.length') == 0">
              There are no transfer agreements for that search. Please try again.
            </h6>
          </div>
          <div class="o-search-result__table-page">
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">{{ page }}</button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import axios from 'axios'
import _ from 'lodash'
import AdultBasicEducationTransferSearchFiltersComponent from './AdultBasicEducationTransferSearchFiltersComponent.vue'
import Paginate from 'vuejs-paginate-next'

const props = defineProps({
  nonce: { type: String, required: true },
  logosUrl: { type: String, required: true },
  apiUrls: { type: Object, required: true },
})

const searchResponse = reactive({
  disciplines: null,
})

const searchFiltersComponentRef = ref(null)

const searchRequestCancelToken = ref(null)
const pdfRequestCancelToken = ref(null)
const pageLength = ref(null)
const pageFrom = ref(null)
const pageTo = ref(null)
const currentPage = ref(1)
const totalPages = ref(0)
const totalAgreements = ref(0)
const currentFilterData = reactive({})

const goToFirstPage = () => {
  currentPage.value = 1
}

const goToLastPage = () => {
  currentPage.value = totalPages.value
}

watch(currentPage, (newCurrentPage, old) => {
  if (newCurrentPage === old || (newCurrentPage === 1 && old === null)) {
    return
  }

  const data = _.clone(currentFilterData)
  _.set(data, 'pageNumber', newCurrentPage)

  submit(data)
})

const submit = (data) => {
  // if pageNumber is not in data, reset it
  Object.assign(currentFilterData, _.clone(data))
  if (data && !Object.prototype.hasOwnProperty.call(data, 'pageNumber')) {
    delete currentFilterData.pageNumber
  }
  searchRequestHandler(
    '/wp-json/bctg-search/adult-basic-education-transfer/agreements',
    currentFilterData,
  )
}

const searchRequestHandler = (path, params) => {
  if (searchRequestCancelToken.value) {
    searchRequestCancelToken.value.cancel()
  }

  searchRequestCancelToken.value = axios.CancelToken.source()
  searchResponse.disciplines = null

  document.body.classList.add('js-is-searching')
  $('html, body').animate({ scrollTop: $('.js-header').offset().top + 200 }, '400')

  axios
    .post(`${path}?_wpnonce=${props.nonce}`, params, {
      cancelToken: searchRequestCancelToken.value.token,
    })
    .then((response) => searchResponseHandler(response))
}

const searchResponseHandler = (response) => {
  Object.assign(searchResponse, response.data)
  document.body.classList.remove('js-is-searching')

  const attributes = {
    currentPage,
    totalPages,
    totalAgreements,
    pageLength,
    pageFrom,
    pageTo,
  }

  Object.keys(attributes).forEach((key) => {
    const value = _.get(searchResponse, key)
    if (value !== attributes[key].value) {
      attributes[key].value = value
    }
  })
}

const downloadPdf = (event) => {
  event.preventDefault()

  const saveToPdfFormElement = document.getElementById('save-to-pdf-form')
  saveToPdfFormElement.action = `/wp-json/bctg-search/adult-basic-education-transfer/agreements/pdf?_wpnonce=${props.nonce}`
  saveToPdfFormElement.innerHTML = ''

  Object.entries(currentFilterData).forEach(([paramName, paramValue]) => {
    const newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.id = paramName
    newInput.name = paramName
    newInput.value = paramValue
    saveToPdfFormElement.append(newInput)
  })

  saveToPdfFormElement.submit()
}

const newSearch = () => {
  searchFiltersComponentRef.value.newSearch()
}

const buildTrailingAttributes = (attributes) => {
  if (attributes != null && attributes.length > 0) {
    let suffix = ''
    let popOverContent = ''

    if (attributes.length > 1) {
      suffix += ' +' + (attributes.length - 1) + ' more'
    }

    attributes.forEach((element, index) => {
      popOverContent += element.label.concat(index === attributes.length - 1 ? '' : ', ')
    })

    if (attributes.length > 0) {
      return `<span class='abe-tooltip' data-tooltip='${popOverContent}' style='position: relative !important;'>${attributes[0].tag.concat(suffix)}</span>`
    }
  }
}

const agreementEffectiveDateDate = (agreement) => {
  const dateFormat = { year: '2-digit', month: 'short' }

  const formatDate = (dateString) => {
    const date = new Date(dateString.slice(0, 4), dateString.slice(4, 6) - 1, 1)
    const formattedDate = new Intl.DateTimeFormat('en-US', dateFormat).format(date)
    return formattedDate.replace(' ', '/')
  }

  let startDate = _.get(agreement, 'startDate')
  if (startDate) {
    startDate = formatDate(startDate)
  }

  let endDate = _.get(agreement, 'endDate')
  if (endDate) {
    endDate = formatDate(endDate)
  }

  if (startDate && endDate) {
    return `${startDate} to ${endDate}`
  }

  if (startDate) {
    return `${startDate} ongoing`
  }

  return ''
}
</script>

<style scoped>
.o-search-results span.abe-tooltip[data-tooltip],
.abe-tooltip {
  position: relative !important;
}
</style>
